module.exports = __webpack_public_path__ + "static/media/Poppins-BoldItalic.09528663.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-BoldItalic.ttf
// module id = 3431
// module chunks = 71